export const inputsFrom = [
  { control: 'usertype', label: 'User type' },
  { control: 'ScheduledDropOffTime', label: 'Scheduled Drop Off Time' },
  { control: 'tripid', label: 'Trip ID' },
  { control: 'dateofservice', label: 'Date of service' },
  { control: 'consecutive', label: 'Consecutive' },
  { control: 'tripstatusid', label: 'Trip status' },
  { control: 'calltypeid', label: 'Call Type' },
  { control: 'leg', label: 'Leg' },
  { control: 'companions', label: 'Companions' },
  { control: 'callreceived', label: 'Call Received' },
  { control: 'addedon', label: 'Created On' },
  { control: 'caller', label: 'Requested by' },
  { control: 'callerphone', label: 'Requester Phone Nbr' },
  { control: 'payorauthorization', label: 'Authorization' },
  { control: 'payorid', label: 'Payor' },
  { control: 'appointment', label: 'Appointment' },
  { control: 'pickup', label: 'Sched. PU' },
  { control: 'returntime', label: 'Returntime' },
  { control: 'reservationid', label: 'Reservation' },
  { control: 'notetrip', label: 'Comments' },
  { control: 'notepickup', label: 'Pick-Up instructions' },
  { control: 'notedropoff', label: 'Drop-Off instructions' },
  { control: 'riderid', label: 'Rider' },
  { control: 'companyid', label: 'Company' },
  { control: 'brokerid', label: 'Brokerid' },
  { control: 'iswillcall', label: 'Will Call' },
  { control: 'isreturntrip', label: 'Is Return' },
  { control: 'vehicleid', label: 'Vehicle' },
  { control: 'driverid', label: 'Driver' },
  { control: 'tripconfirmed', label: 'Trip Confirmed' },
  { control: 'estimatedtime', label: 'Estimated Time' },
  { control: 'activationtime', label: 'Activation' },
  { control: 'noshowtime', label: 'No Show' },
  { control: 'actualdropoff', label: 'Actual dropoff' },
  { control: 'waitingtime', label: 'Waiting' },
  { control: 'actualpickup', label: 'Actual pickup' },
  { control: 'triplocationpickup', label: 'Trip location pickup' },
  { control: 'triplocationdropoff', label: 'Trip location drop off' },
  { control: 'tripreasontransportid', label: 'Reason For Transport' },
  { control: 'tripcancelreasonid', label: 'Cancel Reason' },
  { control: 'totalmiles', label: 'Total miles' },
  { control: 'loadedmiles', label: 'Loaded Mileage' },
  { control: 'manualmiles', label: 'Manual miles' },
  { control: 'totalamount', label: 'Total Charges' },
  { control: 'isnegotiatedrate', label: 'Negotiated Rate' },
  { control: 'totalamountlyft', label: 'Total amount lyft' },
  { control: 'isloadedmiles', label: 'Is loaded miles' },
  { control: 'tripreasonsignid', label: 'Signature' },
  { control: 'signaturephoto', label: 'Signature photo' },
  { control: 'modifiedon', label: 'Modifiedon' },
  { control: 'isactivationnow', label: 'Is activation now' },
  { control: 'facilityid', label: 'Facility' },
  { control: 'facilitydesc', label: 'Facility Description' },
  { control: 'provideramount', label: 'Provider amount' },
  { control: 'faxrequestid', label: 'Fax' },
  { control: '_birthdaterider', label: 'Birth Date Rider' },
  { control: '_policy', label: 'Policy' },
  { control: 'serviceprovidername', label: 'Service Provider' },
  {control: '_isToday', label: 'Today'},
];



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/edit-reservation/edit-reservation-form/controls-form.ts